{
    "Para1": "Selecteer een dashboardlay-out uit de onderstaande opties:",
    "DashboardDisplaySettings_SectionHeader": "Aangepaste instellingen",
    "NAME": "DashboardDisplaySettings"
}